import React, {
   useState,
   useMemo,
   useContext,
   useRef,
   useLayoutEffect,
} from "react";
import useSelectorId from "../../../../utilities/hooks/useSelectorId";
import { translate } from "../../../../utilities/Translate";
import EditorToolbar from "./EditorToolbar";
import { ECLRichTextViewer } from "../../../";
import { ToastContext } from "../../../../utilities/contexts";
import "./ECLRichTextEditor.css";

//PROPS
//onSubmit - function - what happens when the "Submit" button is clicked
//submitButtonText - string - if present, "Submit" button takes this text
//textAreaContent - string - if present, it prefills the textarea with this content
//onCancel - function - if present, it will show a "Cancel" button that fires this function
//onTextChange -function - if present, fires when the user changes the content of the textarea, sends current value
//id - string - if present, will replace textarea id

export default function ECLRichTextEditorFormless(props) {
   const editorId = "rt-editor-" + useSelectorId();
   const addToast = useContext(ToastContext);
   const [previewDisplay, setPreviewDisplay] = useState(false);
   const [inputText, setInputText] = useState(
      props.textAreaContent ? props.textAreaContent : "",
   );
   const editorBoxRef = useRef();
   const [textAreaHeight, setTextAreaHeight] = useState();

   const insertUserLink = (userId) => {
      const userIdFormatted = "![](usr:{" + userId + "})";
      const textArea = document.querySelector("#rt-edit-field" + editorId);
      setInputText(
         (prev) =>
            prev.slice(0, textArea.selectionStart) +
            userIdFormatted +
            prev.slice(textArea.selectionEnd),
      );
   };

   useLayoutEffect(() => {
      const el = editorBoxRef.current;
      setTextAreaHeight(el.clientHeight * 0.8285 + "px"); // Filling up the empty space in modals while keeping the aspect ratio same
   }, []);

   const submitText = (e) => {
      e.preventDefault();
      if (inputText.replaceAll(" ", "") === "") {
         addToast(translate("Cannot add an empty comment"), "error");
         return null;
      }
      if (props.onSubmit) {
         props.onSubmit(inputText);
      } else {
         console.error("No submit function defined");
      }
      setInputText("");
      setPreviewDisplay(false);
   };

   const viewer = useMemo(() => {
      if (previewDisplay) {
         return <ECLRichTextViewer textAsMarkdown={inputText} />;
      }
      return null;
   }, [inputText, previewDisplay]);

   return (
      <div
         onSubmit={submitText}
         className="ecl-rich-text-editor"
         ref={editorBoxRef}
      >
         <div className="tab-container">
            <div className="editor-controls">
               <div className="tab-nav">
                  <button
                     type="button"
                     className={previewDisplay ? "inactive-tab" : ""}
                     onClick={(e) => {
                        e.preventDefault();
                        setPreviewDisplay(false);
                     }}
                  >
                     {" "}
                     {translate("Write")}
                  </button>
                  <button
                     type="button"
                     className={!previewDisplay ? "inactive-tab" : ""}
                     onClick={(e) => {
                        e.preventDefault();
                        setPreviewDisplay(true);
                     }}
                  >
                     {translate("Preview")}
                  </button>
               </div>
               {!previewDisplay && (
                  <EditorToolbar
                     editorId={props.id ? props.id : "rt-edit-field" + editorId}
                     insertUserLink={insertUserLink}
                  />
               )}
            </div>
            {previewDisplay ? (
               <div className="preview-container tab-view">{viewer}</div>
            ) : (
               <div className="edit-container tab-view">
                  <textarea
                     onChange={(e) => {
                        setInputText(e.target.value);
                        if (props.onTextChange) {
                           props.onTextChange(e.target.value);
                        }
                     }}
                     value={inputText}
                     id={props.id ? props.id : "rt-edit-field" + editorId}
                     style={{ height: textAreaHeight }}
                  ></textarea>
                  {/* <div className="file-attachment-temp">GitHub File Attachment Element Will Go Here</div> */}
               </div>
            )}
         </div>
         <div className="button-div">
            {!props.omitSubmit && (
               <button
                  id={`rich-text-submit` + editorId}
                  className="rich-text-submit-button"
                  type="submit"
               >
                  {props.submitButtonText
                     ? props.submitButtonText
                     : translate("Submit")}
               </button>
            )}
            {props.onCancel && (
               <button
                  className="rich-text-cancel-button"
                  onClick={props.onCancel}
               >
                  {translate("Cancel")}
               </button>
            )}
         </div>
      </div>
   );
}
